module.exports = __webpack_public_path__ + "static/media/the-bottles.9d5675d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/beers/the-bottles.jpg
// module id = 590
// module chunks = 0